import LogoSection from './LogoSection';
import useLogoutFn from '@/hooks/useLogoutFn';
import { useEffect } from 'react';
import { SidebarTrigger } from '@layout/Sidebar/Sidebar';
import HeaderActions from './HeaderActions';
import { useTailwindBreakpoint } from '@eye-able/ui';
import { useOrgBranding } from '@/branding/useOrgBranding';

function Header() {
  const xlAndUp = useTailwindBreakpoint('xl');
  const logoutFn = useLogoutFn();
  const branding = useOrgBranding();

  useEffect(() => {
    function logoutOtherTabs(event: StorageEvent) {
      if (event.key === 'logout') {
        void logoutFn(true);
      }
    }

    window.addEventListener('storage', logoutOtherTabs);

    return () => {
      window.removeEventListener('storage', logoutOtherTabs);
    };
  }, [logoutFn]);

  return (
    <header
      id='dashboard-header'
      tabIndex={-1}
      className='eye:bg-white eye:fixed eye:top-0 eye:left-0 eye:w-full eye:z-1299 eye:border-b eye:border-solid eye:border-grey-20 eye:outline-none'
      style={{
        top: 'var(--app-announcement-height, 0px)',
        paddingRight: 'var(--removed-body-scroll-bar-size, 0px)',
        // Brand colours override eye:bg-white / border / text only when
        // configured; `color` lets header icons/text inherit the brand text.
        ...(branding && {
          backgroundColor: branding.brandColor,
          borderBottomColor: branding.brandHoverColor,
          color: branding.brandTextColor,
        }),
      }}
    >
      <div className='eye:flex eye:h-[52px] eye:xl:h-[75px] eye:px-12 eye:xl:px-48 eye:items-center eye:justify-between'>
        <div className='eye:flex eye:items-center'>
          <LogoSection dark />
        </div>
        {xlAndUp ? <HeaderActions /> : <SidebarTrigger />}
      </div>
    </header>
  );
}

export default Header;
